import React from 'react';
import * as Sentry from '@sentry/react';
import { EnvironmentType, config } from 'config';
import { sentryUrlScrubbing } from './scrubUrls';
import { withSentryUser } from './sentryUser';

interface ISentryProviderProps {
  children: React.ReactNode;
}

// What Sentry gets, besides the options below. No URL's query string or
// fragment: a company activation link's token is in its query (scrubUrls.ts).
// An error's user is the Logyx user's id only (sentryUser.ts).
export const sentryEventHooks: typeof sentryUrlScrubbing = {
  ...sentryUrlScrubbing,
  beforeSend: withSentryUser(sentryUrlScrubbing.beforeSend),
};

if (config.sentry.dsnUrl && config.environment !== EnvironmentType.LOCAL) {
  Sentry.init({
    dsn: config.sentry.dsnUrl,
    environment: config.environment,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api-dev.logyx.it/,
      /^https:\/\/api-staging.logyx.it/,
      /^https:\/\/api.logyx.it/,
    ],
    ...sentryEventHooks,
  });
}

const SentryProvider = ({ children }: ISentryProviderProps) => {
  return <>{children}</>;
};

export default SentryProvider;
